import api from "./api";

export default {
  get(id) {
    api.get("game_ready");
    return api.get(`game_summary/${id}`);
  },
  getPlays(id) {
    return api.get(`plays/${id}`);
  },
  getStatQuestion(id, data) {
    return api.post(`ai/game/${id}`, data);
  }
};
